import { useReadableEventRefresher } from '@zdr-tools/zdr-react';
import { useSignInFacade } from './useSignInFacade.js';
/**
 * Reads which login screen shows, re-rendering the caller only when the step changes — not on every countdown tick,
 * failure or loading change the way `useSignIn()` does. Meant for the component that chooses between the steps.
 *
 * Takes no parameters: there is a single sign-in per page. It starts nothing.
 *
 * @returns The current `SignInStep`: `EMAIL` or `CODE`. A finished sign-in keeps the step it happened on (`EMAIL`
 * after Google, `CODE` after a code), locked, while the page navigates away. The sign-in always exists, so there is no "not found" case: before anything
 * happens it is `EMAIL`.
 * @throws Error `useSignInFacade must be used within SignInContextProvider` when called outside a
 * `SignInContextProvider`.
 */
export function useSignInStep() {
    const [[step]] = useReadableEventRefresher(useSignInFacade().getSignIn().step);
    return step;
}
//# sourceMappingURL=useSignInStep.js.map